import React, { Fragment } from "react";
import LinkWrapper from "../linkWrapper/LinkWrapper";
import { getNodesCount, getLink } from "./utils";

const NavMenu = ({ content }) => {
    return (
        <div className="main-menu">
            {content["@nodes"] && (
                <nav>
                    <ul>
                        {content["@nodes"].map((nodeName) => {
                            const nodesCount = getNodesCount(content[nodeName]);

                            return (
                                <li key={nodeName}>
                                    <LinkWrapper
                                        linkNode={content[nodeName].link}
                                        linkClass="menu-link"
                                        renderChildren={true}
                                        fallbackWrapperEl="span"
                                    >
                                        {content[nodeName].link.label}
                                        {nodesCount > 0 && <i className="fa fa-angle-down" />}
                                    </LinkWrapper>

                                    {nodesCount > 0 && (
                                        <ul className={nodesCount > 1 ? "mega-menu mega-menu-padding" : "submenu"}>
                                            {content[nodeName]["@nodes"].map((childNodeName) => {
                                                if (childNodeName === "link") return null;

                                                const link = getLink(content[nodeName], childNodeName);

                                                return (
                                                    <li key={childNodeName}>
                                                        <ul>
                                                            <Fragment>
                                                                {link.linkNode && link.label && (
                                                                    <li className="mega-menu-title">
                                                                        <LinkWrapper
                                                                            linkNode={link.linkNode}
                                                                            renderChildren={true}
                                                                            fallbackWrapperEl="span"
                                                                        >
                                                                            {link.label}
                                                                        </LinkWrapper>
                                                                    </li>
                                                                )}

                                                                {content[nodeName][childNodeName]["@nodes"].map((subchildNodeName) => {
                                                                    if (subchildNodeName === "link") return null;

                                                                    const link = getLink(
                                                                        content[nodeName][childNodeName],
                                                                        subchildNodeName,
                                                                    );

                                                                    if (!link.linkNode || !link.label) return null;

                                                                    return (
                                                                        <li key={subchildNodeName}>
                                                                            <LinkWrapper
                                                                                key={subchildNodeName}
                                                                                linkNode={link.linkNode}
                                                                                renderChildren={true}
                                                                                fallbackWrapperEl="span"
                                                                            >
                                                                                {link.label}
                                                                            </LinkWrapper>
                                                                        </li>
                                                                    );
                                                                })}
                                                            </Fragment>
                                                        </ul>
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    )}
                                </li>
                            );
                        })}
                    </ul>
                </nav>
            )}
        </div>
    );
};

export default NavMenu;
